import { render, staticRenderFns } from "./list_test.vue?vue&type=template&id=21770fe0&scoped=true&"
import script from "./list_test.vue?vue&type=script&lang=js&"
export * from "./list_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21770fe0",
  null
  
)

export default component.exports